module.exports = __webpack_public_path__ + "static/1329429481.b2e37dbd.jpg";